import React, { useEffect } from 'react';
import { Search, X } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './search-input.style';

export type SearchInputProps = {
  value?: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
  isBig?: boolean;
  isAlternative?: boolean;
  preventDrag?: boolean;
};

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
  placeholder,
  isBig,
  isAlternative,
  preventDrag,
}) => {
  const [input, setInput] = React.useState(value ?? '');

  const _onChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setInput(target.value);
    onChange(target.value);
  };

  const clear = () => {
    setInput('');
    onClear ? onClear() : onChange('');
  };

  useEffect(() => {
    value && setInput(value);
  }, [value]);

  return (
    <Styled.Container>
      <Styled.InputContainer
        $hasValue={!!input}
        $isAlternative={!!isAlternative}
        $isBig={!!isBig}
      >
        <Styled.IconContainer $isAlternative={!!isAlternative}>
          <Icon icon={Search} />
        </Styled.IconContainer>
        <Styled.Input
          value={input}
          onChange={_onChange}
          placeholder={placeholder}
          $preventDrag={!!preventDrag}
        />
        {!!input && (
          <Styled.ClearButton
            onClick={clear}
            tabIndex={-1}
            $isAlternative={!!isAlternative}
            $preventDrag={!!preventDrag}
          >
            <Icon icon={X} />
          </Styled.ClearButton>
        )}
      </Styled.InputContainer>
    </Styled.Container>
  );
};
